import { Button, darken, useTheme } from '@mui/material'

import { EChatbotTheme } from '~/features/settings/models'
import { EMarketingClientPath } from '~/models/api'
import { store } from '~/store'
import pathBuilder from '~/utils/api'
import rem from '~/utils/ui'

type TProps = {
  isChatbotPreview?: boolean
}
function CreateYourFreeLibbyButton({ isChatbotPreview = false }: TProps) {
  const theme = useTheme()

  const [chatbotLayout, referralCode] = store((state) => [
    state.chatbot.layout,
    state.organization.referralCode,
  ])
  const linkToHome = referralCode
    ? pathBuilder(EMarketingClientPath.referralLink, { referralCode })
    : EMarketingClientPath.home

  return (
    <Button
      onClick={() => window.open(linkToHome, '_blank')}
      variant="primary"
      sx={{
        backgroundColor:
          chatbotLayout.selection.theme === EChatbotTheme.simple
            ? theme.palette.tertiary3
            : theme.palette.common.white,
        color: theme.palette.mainFont,
        height: 'auto',
        fontSize: isChatbotPreview ? rem(9) : { xxxs: rem(9), sm: rem(12) },
        minWidth: isChatbotPreview ? rem(30) : 'initial',
        lineHeight: isChatbotPreview ? '1.25' : 'initial',
        '&.MuiButton-primaryPrimary': {
          paddingInline: rem(15),
        },
        '&:hover': {
          backgroundColor: darken(theme.palette.tertiary3, 0.1),
        },
      }}
    >
      Create your
      {isChatbotPreview ? <br /> : ''} own free Libby
    </Button>
  )
}
export default CreateYourFreeLibbyButton
